import { PATHS } from "@/lib/router";
import CallForHelpPage from "./pages/CallForHelpPage";

export const callForHelpRoutes = [
  {
    path: PATHS.CALL_FOR_HELP,
    element: <CallForHelpPage />,
  },
];
